import { Form, Head, usePage } from "@inertiajs/react";
import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import SettingsLayout from "@/layouts/settings_layout";

export default function AccountClosure() {
  const { t } = useTranslation();
  const name = usePage().props.auth.account?.name;
  return (
    <SettingsLayout>
      <Head title={t("recovery.delete_account")} />
      <div className="space-y-5">
        <h1 className="text-page font-display">
          {t("recovery.delete_account")}
        </h1>
        <p>{t("recovery.closure_description")}</p>
        <Form action="/user/account_closure" method="post">
          {({ processing, errors }) => (
            <div className="space-y-3">
              <Label htmlFor="confirmation">
                {t("recovery.confirm_name", { name })}
              </Label>
              <Input
                id="confirmation"
                name="confirmation"
                autoComplete="off"
                required
              />
              {errors.base && (
                <p role="alert" className="text-destructive">
                  {errors.base}
                </p>
              )}
              <Button type="submit" variant="destructive" disabled={processing}>
                {t("recovery.delete_account")}
              </Button>
            </div>
          )}
        </Form>
      </div>
    </SettingsLayout>
  );
}
